import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CustomerComponent } from './customer.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [CustomerComponent],
  exports: [
    CustomerComponent
  ],
  providers: [
  ]
})
export class CustomerModule { }
